import React from "react"
import { Id, OperationsContainer, Reason } from "./Shared.styled"
import { OrderCancellation } from "lib/types/generated/graphql-types"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  cancellation: OrderCancellation
}

const CancellationInfo = ({ cancellation }: Props) => {
  const { switchToUpdatesTab } = useOrderTabContext()

  return (
    <OperationsContainer>
      <div>
        <b>Cancellation</b>{" "}
        <div>
          {cancellation?.reason && (<Reason>{cancellation?.reason?.code} - {cancellation?.reason?.cause}</Reason>)}
        </div>{" "}
        <Id onClick={switchToUpdatesTab}>{cancellation.id}</Id>
      </div>
    </OperationsContainer>
  )
}

export default CancellationInfo
